// pages/PlayerPage.tsx — Shared video player for Course & Explore modes
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import VideoPlayer from '../components/player/VideoPlayer';

export default function PlayerPage() {
  const { videoId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') || 'course';

  if (!videoId) {
    return (
      <div className="min-h-screen bg-surface-50 flex items-center justify-center p-6 page-enter">
        <div className="text-center">
          <span className="text-5xl mb-4 block">🚫</span>
          <h2 className="text-lg font-bold text-surface-900 mb-2">Invalid Video Link</h2>
          <p className="text-sm text-surface-300 mb-6">
            The video ID is missing. Please go back and select a lesson.
          </p>
          <button
            onClick={() => navigate(-1)}
            className="touch-btn gradient-mint text-white px-6 py-3"
          >
            ← Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black safe-top safe-bottom page-enter">
      {/* Top Bar */}
      <div className="absolute top-0 left-0 right-0 z-50 flex items-center justify-between px-4 pt-4 safe-top">
        <button
          onClick={() => navigate(-1)}
          className="w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center"
        >
          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
          </svg>
        </button>

        <span className="text-xs text-white/50 font-medium bg-black/30 px-3 py-1 rounded-full backdrop-blur-sm">
          {mode === 'explore' ? 'Explore' : 'Course'}
        </span>
      </div>

      {/* Player */}
      <div className="w-full pt-16">
        <VideoPlayer
          videoId={videoId}
          mode={mode as 'course' | 'explore'}
          onTimeUpdate={() => {}}
          onEnded={() => console.log('Lesson completed')}
          onNext={() => {
            if (mode === 'explore') {
              navigate(-1); // Go back to explore feed
            } else {
              navigate(-1); // Go back to lessons list
            }
          }}
          onBackToTopics={() => {
            navigate('/course');
          }}
        />
      </div>
    </div>
  );
}
